export default class FormValidation {
  constructor(settings = {
    onAfterInvalid() { },
    onBeforeSubmit() { },
    onAfterSubmit(data, dataSuccess, response, status, xhr, Form) {},
  }) {
    this.settings = settings;
    this.options = {
      activeClass: 'js-validation--init',
    };
    this.$el = $(`form.js-validation:not(.${this.options.activeClass})`);

    return this;
  }

  init() {
    const _this = this;

    this.$el.each((index, element) => {
      let validationData = {
        $selectorWarnText: null,
        $selectorResponse: null,
        $selectorPreloader: null,
        $response: null,
        noResponse: null,
      };
      let validationSettings = [];
      const $this = $(element);
      const submitData = $this.data('submit');
      const submitFailData = $this.data('submit-fail');
      const submitSuccessData = $this.data('submit-success');
      let $selectorWarnText;
      let $selectorPreloader;
      let $selectorResponse;

      validationData = $this.data('validation') || validationData;

      if (validationData.$selectorWarnText !== null) {
        $selectorWarnText = $(validationData.$selectorWarnText);
      } else $selectorWarnText = $this.find('.js-validation--warn-text');

      if (validationData.$selectorPreloader !== null) {
        $selectorPreloader = $(validationData.$selectorPreloader);
      } else $selectorPreloader = $this.find('.js-validation--preloader');

      if (validationData.$selectorResponse !== null) {
        $selectorResponse = $(validationData.$selectorResponse);
      } else $selectorResponse = $this;

      if ($this.data('validation-settings')) validationSettings = $this.data('validation-settings');
      validationSettings.invalidHandler = () => {
        $this.ajaxSubmit({
          data: { isNaked: 1 },
          success: (response, status, xhr, form) => {
            const $form = $(form);
            const $response = $(response);
            const $responseWarnText = $response.filter('.warnText');

            if ($responseWarnText.length && $responseWarnText.length !== false) {
              $selectorWarnText.addClass('--active').html($responseWarnText);
            } else {
              $selectorWarnText.addClass('--active').html($response);
            }

            this.settings.onAfterInvalid(submitData, submitFailData, response, status, xhr, form);
          },
        });
      };

      validationSettings.submitHandler = (form) => {
        const $form = $(form);
        const $buttonSubmit = $form.find('.js-validation--button-submit');
        let buttonSubmitTextCurrent = '';

        // Заблокировать кнопку
        if ($buttonSubmit.length) {
          const buttonSubmitTextReplace = $buttonSubmit.data('validation-text-submit') || 'Отправка…';
          buttonSubmitTextCurrent = $buttonSubmit.html();

          $buttonSubmit.prop('disabled', true).html(buttonSubmitTextReplace);
        }

        if (validationData.ajax !== 'false') {
          $form.ajaxSubmit({
            data: { isNaked: 1 },
            beforeSubmit: (arr, $form, options) => {
              if (this.settings.onBeforeSubmit) {
                this.settings.onBeforeSubmit(arr, $form, options);
              }

              if ($selectorPreloader.length) {
                $($selectorPreloader).removeClass('-hide');
              }
            },
            success: (response, status, xhr, form) => {
              if (validationData.noResponse !== false) {
                const $response = $(response);

                let $responseIn;
                if (validationData.$response) $responseIn = $response.find(validationData.$response);
                else if ($response.filter('.js-validation--response').length) $responseIn = $response.filter('.js-validation--response');
                else $responseIn = $response.find('.js-validation--response');
                if (!$responseIn.length) $responseIn = $response;

                let $warnText;
                if ($response.filter('#nc_modal_status').length) $warnText = $response.filter('#nc_modal_status');
                else $warnText = $response.find('#nc_modal_status');

                if (validationData.tooltip) {
                  const $tooltip = $form.find('.js-tooltip');
                  $tooltip.addClass('tooltip_active');
                  setTimeout(() => {
                    $tooltip.removeClass('tooltip_active');
                  }, 3000);
                } else if ($warnText.length) {
                  $selectorWarnText.addClass('--active').html($warnText);
                } else if ($selectorResponse.length) $selectorResponse.addClass('--active').html($responseIn);
              }

              // Разблокировать кнопку
              if ($buttonSubmit.length) {
                $buttonSubmit.prop('disabled', false).html(buttonSubmitTextCurrent);
              }

              // История в браузере
              if (validationData.history) history.pushState(null, null, `${$(form).attr('action')}?${$(form).formSerialize()}`);

              // Скрыть загрузчик
              if (validationData.preloader) {
                $(validationData.preloader).addClass('-hide');
              }

              _this.settings.onAfterSubmit(submitData, submitSuccessData, response, status, xhr, form);

              new FormValidation().init();
            },
          });
        }
      };

      $this.addClass(_this.options.activeClass).validate(validationSettings);
    });
  }

  render() {
    if (this.$el.length) {
      this.init();
    }
    return this;
  }
}
